import { create } from 'zustand';

type ToastInput = {
  actionLabel?: string;
  durationMs?: number;
  message: string;
  onAction?: () => void;
};

type ToastState = {
  dismissToast: () => void;
  toast: ToastInput | null;
  showReadOnlyMarketToast: () => void;
  showToast: (toast: ToastInput) => void;
};

const DEFAULT_TOAST_DURATION_MS = 3000;
const READ_ONLY_MARKET_TOAST_MESSAGE = "You're outside San Antonio. Radious is live there for now.";

let dismissTimer: ReturnType<typeof setTimeout> | null = null;

function clearDismissTimer() {
  if (!dismissTimer) {
    return;
  }

  clearTimeout(dismissTimer);
  dismissTimer = null;
}

export const useToastStore = create<ToastState>((set, get) => ({
  toast: null,
  dismissToast: () => {
    clearDismissTimer();
    set({ toast: null });
  },
  showReadOnlyMarketToast: () => {
    get().showToast({
      durationMs: DEFAULT_TOAST_DURATION_MS,
      message: READ_ONLY_MARKET_TOAST_MESSAGE,
    });
  },
  showToast: (toast) => {
    clearDismissTimer();
    set({ toast });
    dismissTimer = setTimeout(() => {
      set((state) => (state.toast === toast ? { toast: null } : state));
      dismissTimer = null;
    }, toast.durationMs ?? DEFAULT_TOAST_DURATION_MS);
  },
}));

export function showReadOnlyMarketToast() {
  useToastStore.getState().showReadOnlyMarketToast();
}

export function showToast(toast: ToastInput) {
  useToastStore.getState().showToast(toast);
}
